/** Shared card styles — forest green (green-*) + earthy tan (gold-*) */
export const cardTheme = {
  shell:
    'bg-white rounded-2xl border border-green-200/70 shadow-md shadow-green-900/10 overflow-hidden',
  shellHover:
    'hover:border-gold-400/50 hover:shadow-lg hover:shadow-green-900/15 transition-all duration-200',
  accentTop: 'border-t-4 border-t-gold-500',
  headerBanner: 'bg-gradient-to-br from-green-900 via-green-800 to-green-700',
  innerPanel:
    'bg-white rounded-t-2xl border border-green-100 shadow-sm',
  feature:
    'bg-gradient-to-br from-green-50/70 via-white to-gold-50/30 rounded-2xl border border-green-100 p-6 hover:border-gold-400/60 hover:shadow-md transition-all duration-200',
  courseCard:
    'bg-white rounded-2xl border border-green-200/70 shadow-md shadow-green-900/10 overflow-hidden hover:border-gold-400/50 hover:shadow-lg hover:shadow-green-900/15 transition-all duration-200 h-full',
  title: 'text-green-800 font-thmanyah',
  subtitle: 'text-gray-600',
  badge:
    'inline-flex items-center gap-2 bg-green-50 text-green-800 border border-green-200 px-3 py-1 rounded-full text-xs sm:text-sm font-semibold',
  badgeGold:
    'inline-flex items-center gap-2 bg-gold-50 text-gold-700 border border-gold-200 px-3 py-1 rounded-full text-xs sm:text-sm font-semibold',
  btnPrimary:
    'bg-green-700 hover:bg-green-800 text-white font-semibold transition-colors',
  btnOutline:
    'border border-green-700 text-green-700 hover:bg-green-50 font-semibold transition-colors',
  btnGold:
    'bg-gold-500 hover:bg-gold-400 text-green-950 font-semibold transition-colors',
  divider: 'bg-gold-400',
  price: 'text-green-700 font-bold',
  iconBox: 'bg-green-700 text-white',
  iconBoxGold: 'bg-gold-500 text-green-950',
};
